/**
 * use-zalo-label-import.ts — Nhập nhãn Zalo PC sang eCDP (xem trước → nhập). API: backend modules/zalo/zalo-label-routes.ts.
 *   POST /zalo-accounts/:id/labels/preview   không ghi gì
 *   POST /zalo-accounts/:id/labels/import    thêm nhãn mới + gắn nhãn cho khách / nhóm (chỉ thêm, không gỡ, không chạy tự động hoá)
 */
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import type { ZaloLabelTotals } from '@/lib/zalo-label-import'

export interface ZaloLabelTagPlan {
  name: string
  color: string
  isNew: boolean
  conversations: number
  matched: number
  unmatched: number
  newAssignments: number
}

export interface ZaloLabelPreview {
  /** Lúc lấy nhãn từ Zalo (ISO). Zalo chỉ được hỏi 1 lần / 5 phút / tài khoản — xem trước rồi nhập dùng cùng một bản. */
  fetchedAt: string
  cached: boolean
  tags: ZaloLabelTagPlan[]
  totals: ZaloLabelTotals
}

export interface ZaloLabelImportResult extends ZaloLabelPreview {
  written: number
  skippedOverLimit: number
}

export function useZaloLabelPreview() {
  return useMutation({
    mutationFn: async (accountId: string) => (await api.post<ZaloLabelPreview>(`/zalo-accounts/${accountId}/labels/preview`)).data,
  })
}

export function useZaloLabelImport() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (accountId: string) => (await api.post<ZaloLabelImportResult>(`/zalo-accounts/${accountId}/labels/import`)).data,
    onSuccess: () => {
      // Danh mục nhãn + nhãn trên khách / dòng hội thoại / số đếm đều đã đổi.
      for (const key of ['tags', 'conversations', 'conversation-counts', 'contacts', 'contact']) void qc.invalidateQueries({ queryKey: [key] })
    },
  })
}
